const fieldLabels: Record<string, string> = {
  id: '编号', version: '版本', name: '名称', title: '标题', description: '说明', note: '备注', code: '代码',
  createdAt: '创建时间', updatedAt: '更新时间', occurredAt: '发生时间', receivedAt: '接收时间', requestedAt: '请求时间',
  from: '开始时间', to: '结束时间', balances: '资金汇总', received: '收入', spent: '支出', net: '净额',
  completedAt: '完成时间', deliveredAt: '下发时间', observedAt: '观测时间', capturedAt: '截图时间', lastSeenAt: '最近时间',
  userName: '用户名', normalizedUserName: '规范用户名', displayName: '显示名称', role: '角色', roleId: '角色编号',
  permissions: '权限', permissionsJson: '权限', isActive: '是否启用', lastLoginAt: '最后登录时间', sessionVersion: '会话版本',
  orderNumber: '订单号', customerChannel: '客户或渠道', item: '商品', orderedQuantity: '订购数量', shippedQuantity: '发货数量',
  amountDue: '应收金额', amountReceived: '已收金额', paymentStatus: '付款状态', receiptConfirmedAt: '确认收货时间',
  projectId: '项目编号', projectName: '项目', accountId: '账号编号', status: '状态', source: '来源', sourceNote: '来源备注',
  category: '分类', amount: '金额', currency: '币种', paymentMethod: '支付方式', paymentAccount: '支付账户',
  orderId: '订单编号', counterparty: '交易对方', isVoided: '是否作废', voidedAt: '作废时间', voidReason: '作废原因',
  method: '收款方式', receivedBy: '收款人', operatorName: '系统登记人', reference: '交易单号', reversalReason: '冲正原因', exceptionReason: '作废或异常原因',
  deviceId: '设备编号', deviceName: '设备', deviceKey: '设备键', groupName: '分组', lifecycleState: '生命周期状态',
  online: '在线状态', abnormal: '是否异常', requestPending: '等待截图', requestStatus: '截图请求状态',
  requestFailureCode: '截图失败原因', requestRequestedAt: '截图请求时间', requestCompletedAt: '截图完成时间',
  capabilitiesJson: '能力信息', agentVersion: '客户端版本',
  entityType: '实体类型', externalId: '外部编号', state: '状态', value: '值', sourceInstance: '来源实例',
  action: '动作', automationKey: '自动化键', targetKind: '目标类型', targetCount: '目标数量', summary: '汇总',
  pending: '待处理', delivered: '已下发', succeeded: '成功', failed: '失败', expired: '已过期', safeResultJson: '安全结果',
  sku: '物料编码', trackingMode: '跟踪模式', quantityOnHand: '可用库存', reorderLevel: '补货线', serialNumber: '序列号',
  itemId: '库存项目编号', itemName: '库存项目', assetId: '资产编号', repairId: '维修单编号', expenseId: '支出编号',
  kind: '类型', quantity: '数量', testPassed: '测试是否通过', ticketNumber: '维修单号', resolution: '处理结论',
  income: '收入', expense: '支出', balance: '经营余额', priorIncome: '上期收入', priorExpense: '上期支出',
  priorBalance: '上期余额', incomeChangePercent: '收入环比', expenseChangePercent: '支出环比', balanceChangePercent: '余额环比',
  period: '日期', totalOrders: '订单总数', completedOrders: '已完成订单', completionPercent: '完成率',
  utilizationPercent: '心跳覆盖率', repairDowntimeHours: '维修停机小时', abnormalEventCount: '异常事件数', efficiencyPercent: '设备效率',
  type: '类型', count: '次数', criticalCount: '错误或严重次数', affectedDevices: '涉及设备', affectedProjects: '涉及项目',
  firstSeenAt: '首次出现', current: '当前值', previous: '上期值', changePercent: '变化比例',
  direction: '趋势方向', unit: '单位', evidence: '依据', evidenceCount: '依据数量', confidence: '可信度', scope: '范围',
  horizonDays: '预计天数', hypothesis: '原因假设', caveat: '限制说明', priority: '优先级', recommendation: '建议',
  requiresHumanApproval: '需要人工批准', executionAllowed: '允许自动执行', executionState: '执行状态', reason: '原因',
  overallStatus: '整体状态', activeDevices: '有效设备', onlineDevices: '在线设备', offlineDevices: '离线设备',
  unfinishedOrders: '未完成订单', unresolvedIncidents: '未关闭事件单', openRepairs: '处理中维修单', lowStockItems: '低库存项目',
  failedAutomationCommands: '失败或过期自动化命令', hasDevices: '有设备数据', hasOrders: '有订单数据', hasEvents: '有事件数据',
  hasMetrics: '有指标数据', eventSampleLimitReached: '事件样本达到上限', metricSampleLimitReached: '指标样本达到上限',
  limitations: '数据限制', aggregateHash: '证据哈希', dataWatermark: '数据水位', readOnly: '只读',
  currentPercent: '当前比例', previousPercent: '上期比例', currentOrders: '当前订单数', latestBytes: '最新可用字节数',
  changeBytesPerDay: '每日变化字节数', samples: '样本数', events: '事件数', devices: '设备数', projects: '项目数',
  signatures: '特征数', repair: '维修项', repairStatus: '维修状态', critical: '严重事件数',
  settingsKey: '设置键', key: '键', valueJson: '配置内容', actorUserId: '操作用户编号', operation: '操作', result: '结果',
  targetType: '对象类型', targetId: '对象编号', resourceType: '对象类型', resourceId: '对象编号', outcome: '结果',
  beforeJson: '变更前', afterJson: '变更后', safeBeforeJson: '变更前', safeAfterJson: '变更后', correlationId: '关联编号',
  ipAddress: '网络地址', queryType: '查询类型', explanation: '说明', verifiedFacts: '已核实数据',
};

const valueLabels: Record<string, string> = {
  Administrator: '管理员', Active: '启用', Disabled: '停用', Retired: '已退役',
  Pending: '待处理', Locked: '已锁定', Shipped: '已发货', Completed: '已完成', Exception: '异常', Cancelled: '已取消',
  Unpaid: '未付款', Partial: '部分付款', Paid: '已付款', Open: '待处理', Handling: '处理中', Resolved: '已解决', Closed: '已关闭',
  Trace: '跟踪', Debug: '调试', Information: '信息', Warning: '警告', Error: '错误', Critical: '严重',
  OnDemand: '按需', Interval: '定时', Delivered: '已下发', Failed: '失败', Expired: '已过期', Succeeded: '成功',
  Start: '启动', Stop: '停止', Pause: '暂停', Resume: '恢复', Status: '查询状态',
  Unknown: '未知', Starting: '启动中', Running: '运行中', Paused: '已暂停', Stopping: '停止中', Stopped: '已停止',
  Quantity: '数量库存', Serialized: '序列化资产', InStock: '在库', Issued: '已领用', Installed: '已安装', Faulty: '故障', Rma: '返厂', Scrapped: '已报废',
  Receive: '收货', Issue: '出库', Install: '安装', Remove: '拆卸', Test: '测试', Scrap: '报废',
  Diagnosing: '诊断中', Repairing: '维修中', Testing: '测试中',
  DiskFreeBelowGiB: '磁盘可用空间低于阈值', MemoryFreeBelowMiB: '内存可用量低于阈值',
  CpuAbovePercentForDuration: '处理器持续高于阈值', HeartbeatTimeout: '心跳超时',
  project: '项目', account: '账号', thread: '线程', task: '任务', emulator: '模拟器', goods: '商品', source: '来源', custom: '自定义',
  devices: '设备', group: '分组', orders: '订单', events: '事件', inventory: '库存', predictions: '预测预警', studio: '运营中心',
  stable: '稳定', up: '上升', down: '下降', count: '数量', percent: '百分比',
  healthy: '正常', attention: '需要关注', critical: '严重', high: '高', medium: '中', low: '低',
  'proposal-only': '仅生成提案', 'shared-event-pattern': '共同事件特征', 'project-event-concentration': '项目事件集中',
  'completion-rate-decline': '订单完成率下降', 'abnormal-event-growth': '异常事件增长',
  'disk-threshold-breached': '磁盘空间已低于阈值', 'disk-capacity-forecast': '磁盘容量预测',
  'inspect-agent-connectivity': '检查设备客户端连接', 'prepare-inventory-reorder': '准备库存补货审核',
  'review-predictive-warning': '审核预测预警', 'no_action_threshold_triggered': '未触发行动阈值',
  'orders.created': '新建订单数', 'orders.completion_percent': '订单完成率', 'events.abnormal': '异常事件数', 'incidents.created': '新建事件单数',
  'today-summary': '今日运营概览', 'pending-orders': '未完成订单', unpaid: '未收款订单',
  'offline-devices': '离线设备', 'disk-low': '磁盘空间不足设备', 'event-trends': '今日事件趋势',
  'compare-yesterday': '与昨日对比', 'compare-7-days': '与近七日对比', 'daily-summary': '每日运营摘要',
  daily: '日报', weekly: '周报', monthly: '月报',
  electricity: '电费', internet: '网络费', IP: '网络地址费用', 'project cost': '项目成本', salary: '工资', rent: '租金',
  hardware: '硬件', repair: '维修', 'software/service': '软件或服务', 'cloud phone': '云手机', other: '其他', manual: '人工',
  WeChat: '微信', Alipay: '支付宝', BankTransfer: '银行转账', Cash: '现金', Other: '其他',
  CNY: '人民币', USD: '美元', EUR: '欧元', HKD: '港币',
  'users.manage': '用户管理', 'orders.read': '查看订单', 'orders.write': '管理订单', 'finance.read': '查看收支',
  'finance.write': '管理收支', 'devices.read': '查看设备', 'devices.manage': '管理设备', 'events.read': '查看事件',
  'events.handle': '处理事件', 'rules.manage': '管理规则', 'ai.query': '使用智能分析', 'settings.manage': '管理系统设置',
  'audit.read': '查看操作审计', 'automation.read': '查看自动化', 'automation.control': '控制自动化',
  'inventory.read': '查看库存', 'inventory.manage': '管理库存', 'bi.read': '查看经营分析',
  'income.write': '登记其他收入', 'income.void': '作废其他收入', 'agent.publish': '发布 Agent 版本',
  'stock.read': '查看业务商品库存', 'stock.manage': '管理业务商品库存',
  sdk: '本地接入组件', agent: '设备客户端', rules: '规则引擎', web: '网页端', api: '接口', system: '系统', success: '成功',
  user: '用户', role: '角色', setting: '系统设置', order: '订单', incident: '事件单', device: '设备',
  expense: '支出', inventory_item: '库存项目', automation_batch: '自动化批次',
  automation_command: '自动化命令', ai_insight: '智能分析报告', 'agent-enrollment-token': '客户端接入令牌',
  'auth.bootstrap': '初始化管理员', 'auth.login': '用户登录', 'user.create': '创建用户', 'user.disable': '停用用户',
  'role.create': '创建角色', 'setting.put': '保存系统设置', 'project.create': '创建项目', 'order.create': '创建订单',
  'order.lock': '锁定订单来源', 'order.ship': '订单发货', 'order.payment.receive': '登记订单收款',
  'order.correct': '修正订单录入', 'order.payment.reverse': '冲正订单收款',
  'order.payment.correct': '更正收款信息', order_payment: '订单收款',
  'order.receipt.confirm': '确认订单收货', 'order.complete': '完成订单', 'order.exception': '标记订单异常', 'order.cancel': '取消订单',
  'expense.create': '登记支出', 'expense.correct': '修正支出录入', 'expense.void': '作废支出', 'device.assignment.update': '更新设备归类', 'device.retire': '移除设备',
  'agent.enrollment-token.create': '创建客户端接入令牌', 'agent.register': '注册设备客户端', 'agent.revoke': '撤销设备客户端',
  'incident.create': '创建事件单', 'incident.event.link': '关联事件', 'incident.transition': '变更事件单状态',
  'rule.create': '创建规则', 'rule.update': '更新规则', 'screenshot.request': '请求设备截图',
  screenshot_no_active_session: '没有可用的交互桌面会话', screenshot_user_token_failed: '无法取得当前登录用户会话',
  screenshot_user_token_duplicate_failed: '无法创建当前登录用户的截图进程', screenshot_capture_timeout: '截图操作超时',
  screenshot_desktop_capture_failed: '桌面截图失败', screenshot_desktop_unavailable: '交互桌面不可用', screenshot_screen_dc_failed: '无法读取桌面画面',
  screenshot_memory_dc_failed: '无法创建截图缓冲区', screenshot_bitmap_create_failed: '无法创建截图位图',
  screenshot_bitblt_failed: '桌面复制失败', screenshot_dxgi_capture_failed: 'DirectX 桌面捕获失败',
  screenshot_dxgi_device_failed: 'DirectX 截图设备不可用', screenshot_dxgi_duplication_failed: '当前显示环境不支持 DirectX 桌面复制',
  screenshot_dxgi_frame_failed: '无法取得 DirectX 桌面帧', screenshot_dxgi_readback_failed: '无法读取 DirectX 桌面帧',
  screenshot_wgc_capture_failed: 'Windows 图形捕获失败', screenshot_wgc_unsupported: '当前系统不支持 Windows 图形捕获',
  screenshot_wgc_device_failed: 'Windows 图形捕获设备不可用', screenshot_wgc_frame_timeout: '等待 Windows 图形画面超时',
  screenshot_wgc_readback_failed: '无法读取 Windows 图形画面', screenshot_wgc_item_failed: '无法创建 Windows 图形捕获目标',
  screenshot_wgc_session_failed: '无法启动 Windows 图形捕获会话', screenshot_png_encode_failed: '截图图片编码失败',
  screenshot_blank_frame: '当前远程桌面只返回黑屏', screenshot_output_write_failed: '截图文件写入失败', screenshot_files_missing: '截图文件没有生成',
  screenshot_upload_failed: '截图上传被服务器拒绝', screenshot_capture_failed: '截图失败', screenshot_helper_failed: '截图辅助进程失败',
  request_expired: '截图请求已过期', delivery_attempts_exhausted: '截图请求重试次数已用尽', device_retired: '设备已移除',
  'automation.batch.create': '创建自动化批次', 'automation.command.result': '自动化命令回报',
  'inventory.item.create': '创建库存项目', 'inventory.receive': '库存收货', 'inventory.movement': '登记库存动作',
  'repair.create': '创建维修单', 'repair.transition': '变更维修单状态', 'ai.executive-report.generate': '生成管理报告',
  'stage00.migration.smoke': '数据库迁移检查', database: '数据库', pass: '通过',
};

export function fieldLabel(key: string): string {
  return fieldLabels[key] ?? key;
}

export function valueLabel(value: string): string {
  const exact = valueLabels[value];
  if (exact) return exact;
  if (value.startsWith('finance.income.')) return `${valueLabel(value.slice('finance.income.'.length))}收入`;
  if (value.startsWith('finance.expense.')) return `${valueLabel(value.slice('finance.expense.'.length))}支出`;
  const pairs = value.split(';');
  if (pairs.length > 1 && pairs.every((pair) => /^[A-Za-z][A-Za-z0-9_.]*=/.test(pair))) {
    return pairs.map((pair) => {
      const separator = pair.indexOf('=');
      return `${fieldLabel(pair.slice(0, separator))}：${pair.slice(separator + 1)}`;
    }).join('；');
  }
  const colon = value.indexOf(':');
  if (colon > 0 && valueLabels[value.slice(0, colon)]) {
    return `${valueLabels[value.slice(0, colon)]}：${value.slice(colon + 1)}`;
  }
  return value;
}

export function formatDisplay(value: unknown): string {
  if (value === null || value === undefined || value === '') return '-';
  if (typeof value === 'boolean') return value ? '是' : '否';
  if (typeof value === 'number') return new Intl.NumberFormat('zh-CN', { maximumFractionDigits: 2 }).format(value);
  if (Array.isArray(value)) return value.length ? value.map(formatDisplay).join('；') : '无';
  if (typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>).map(([key, item]) => `${fieldLabel(key)}：${formatDisplay(item)}`).join('；');
  }
  const text = String(value);
  if (/^\d{4}-\d{2}-\d{2}T/.test(text)) {
    const date = new Date(text);
    if (!Number.isNaN(date.getTime())) return date.toLocaleString('zh-CN');
  }
  if ((text.startsWith('{') && text.endsWith('}')) || (text.startsWith('[') && text.endsWith(']'))) {
    try { return formatDisplay(JSON.parse(text)); } catch { /* keep original data */ }
  }
  return valueLabel(text);
}
